import { useState } from 'react';
import { G } from '../theme';
import { PAYMENT_METHODS } from '../data';
import FadeIn from './FadeIn';

export default function PaymentMethods() {
  const [selected, setSelected] = useState('');

  const group = PAYMENT_METHODS.find(p => p.countries.includes(selected));

  return (
    <section style={{ background: G.g100, padding: '64px 24px' }}>
      <div style={{ maxWidth: 600, margin: '0 auto' }}>
        <FadeIn>
          <div style={{
            background: '#fff',
            border: `2px solid ${G.amber}`,
            borderRadius: 20,
            padding: '32px 28px',
            boxShadow: '0 12px 40px rgba(239,159,39,0.18)',
          }}>
            <div style={{ display: 'inline-flex', alignItems: 'center', gap: 6, background: G.amberBg, color: '#8A5A0F', fontSize: 12, fontWeight: 700, padding: '5px 14px', borderRadius: 20, marginBottom: 16 }}>
              ⭐ Important
            </div>
            <div style={{ display: 'flex', alignItems: 'center', gap: 12, marginBottom: 8 }}>
              <div style={{ width: 4, height: 32, background: G.g600, borderRadius: 2, flexShrink: 0 }} />
              <h2 style={{ fontFamily: "'Playfair Display',serif", fontSize: '1.8rem', fontWeight: 700, margin: 0 }}>
                Moyens de paiement selon votre pays
              </h2>
            </div>
            <p style={{ color: G.gray6, fontSize: 15, marginBottom: 24, paddingLeft: 16 }}>
              Sélectionnez votre pays pour voir les coordonnées de paiement
            </p>

            <select
              value={selected}
              onChange={e => setSelected(e.target.value)}
              style={{
                width: '100%',
                boxSizing: 'border-box',
                padding: '15px 18px',
                borderRadius: 12,
                border: `1.5px solid ${selected ? G.g600 : '#D8D8D2'}`,
                background: '#fff',
                color: selected ? '#2C2C2A' : G.gray6,
                fontSize: 15,
                fontWeight: 600,
                fontFamily: 'inherit',
                cursor: 'pointer',
                outline: 'none',
              }}
            >
              <option value="">🌍 Choisissez votre pays…</option>
              {PAYMENT_METHODS.map((p, i) => (
                <optgroup key={i} label={p.flag + ' ' + p.countries.join(' · ')}>
                  {p.countries.map(c => (
                    <option key={c} value={c}>{c}</option>
                  ))}
                </optgroup>
              ))}
            </select>

            {group && (
              <div style={{ background: G.g100, border: `1.5px solid ${G.g600}`, borderRadius: 14, padding: '22px 24px', marginTop: 16 }}>
                <div style={{ display: 'flex', alignItems: 'flex-start', gap: 10, marginBottom: 12 }}>
                  <span style={{ fontSize: 22, lineHeight: 1 }}>{group.flag}</span>
                  <div>
                    <div style={{ fontSize: 15, fontWeight: 700, color: '#2C2C2A', lineHeight: 1.3 }}>{selected}</div>
                    <div style={{ fontSize: 12, color: G.gray6, marginTop: 2 }}>{group.contact}</div>
                  </div>
                </div>
                <div style={{ display: 'flex', flexDirection: 'column', gap: 8, borderTop: `1px solid #fff`, paddingTop: 12 }}>
                  {group.methods.map((m, mi) => (
                    <div key={mi} style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'baseline', gap: 12, flexWrap: 'wrap' }}>
                      <span style={{ fontSize: 13, fontWeight: 600, color: G.g700 }}>{m.label}</span>
                      <span style={{ fontSize: 14, fontWeight: 600, color: '#2C2C2A' }}>{m.value}</span>
                    </div>
                  ))}
                </div>
              </div>
            )}

            <p style={{ fontSize: 13, color: G.gray6, marginTop: 20, textAlign: 'center' }}>
              📌 Votre pays n'apparaît pas ? Choisissez "Autre pays" ou écrivez-nous sur WhatsApp.
            </p>
          </div>
        </FadeIn>
      </div>
    </section>
  );
}
